const routes = [
  {
    path: '/relatorio/glosa',
    name: 'glosas',
    component: () => import('@/views/relatorio/servico/Glosas.vue'),
    meta: { breadcrumb: [{ title: 'Relat\u00f3rios' }, { title: 'Ordens de Servi\u00e7o' }, { title: 'Glosa' }] },
  },
  // {
  //   path: '/relatorio/osRetroativos',
  //   name: 'osRetroativo',
  //   component: () => import('@/views/relatorio/servico/OsRetroativo.vue'),
  //   meta: {
  //     breadcrumb: [
  //       { title: 'Relat\u00f3rios' },
  //       { title: ' Ordens de servi\u00e7o' },
  //       { title: 'Ordens de Servi\u00e7o Retroativos' },
  //     ],
  //   },
  // },
  // {
  //   path: '/relatorio/comparativo',
  //   name: 'comparativo',
  //   component: () => import('@/views/relatorio/servico/Comparativo.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relat\u00f3rios' }, { title: 'Ordens de servi\u00e7o' }, { title: 'Comparativo de valores' }],
  //   },
  // },
  // {
  //   path: '/relatorio/quantidade-servicos',
  //   name: 'quantidadeServicos',
  //   component: () => import('@/views/relatorio/servico/QuantidadeServicos.vue'),
  //   meta: {
  //     breadcrumb: [
  //       { title: 'Relat\u00f3rios' },
  //       { title: 'Ordens de Servi\u00e7o' },
  //       { title: 'Quantidade de Servi\u00e7os por Per\u00edodo' },
  //     ],
  //   },
  // },
]

export default routes